import React from 'react';
import { Select, Typography } from 'antd';

const { Text } = Typography;

const NerSummary = ({
    isNerJsonMode,
    nerFieldAssignments,
    handleManualNerAssignment,
    jsonFieldSelectOptions,
    entityFieldConfig,
    relationFieldConfig,
    supportsRelationFields,
    parserOutput, // New prop
    readOnly = false,
}) => {
    // Handle Parser Output Mode (Custom / Validation Result)
    if (parserOutput) {
        const entities = parserOutput.entities || [];
        const relations = parserOutput.relations || [];

        return (
            <div
                className="response-step-card__ner-summary"
                style={{
                    marginTop: 16,
                    border: '1px solid #e5e5e5',
                    borderRadius: 12,
                    padding: 16,
                    background: '#fff',
                }}
            >
                <Text strong style={{ display: 'block', marginBottom: 12 }}>Entities ({entities.length})</Text>
                <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                    {entities.length > 0 ? entities.map((e, i) => (
                        <div key={i} style={{
                            marginBottom: 8,
                            paddingBottom: 8,
                            borderBottom: '1px solid #f0f0f0',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 4,
                        }}>
                            <div><Text type="secondary">Label:</Text> <Text code>{e.label}</Text></div>
                            <div><Text type="secondary">Content:</Text> <Text code>{e.content}</Text></div>
                            <div><Text type="secondary">Start Index:</Text> <Text code>{e.start_index}</Text></div>
                        </div>
                    )) : <Text type="secondary">No entities found</Text>}
                </div>

                {supportsRelationFields && (
                    <>
                        <div style={{ height: 1, background: '#eee', margin: '16px 0' }} />
                        <Text strong style={{ display: 'block', marginBottom: 12 }}>Relations ({relations.length})</Text>
                        <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                            {relations.length > 0 ? relations.map((r, i) => (
                                <div key={i} style={{
                                    marginBottom: 8,
                                    paddingBottom: 8,
                                    borderBottom: '1px solid #f0f0f0',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 4,
                                }}>
                                    <div><Text type="secondary">Label:</Text> <Text code>{r.label}</Text></div>
                                    <div><Text type="secondary">Source Start:</Text> <Text code>{r.source_start_index}</Text></div>
                                    <div><Text type="secondary">Target Start:</Text> <Text code>{r.target_start_index}</Text></div>
                                </div>
                            )) : <Text type="secondary">No relations found</Text>}
                        </div>
                    </>
                )}
            </div>
        );
    }

    if (!isNerJsonMode) {
        return null;
    }

    const renderNerFieldSelector = (assignment, fieldKey) => (
        <Select
            showSearch
            allowClear
            placeholder="Select from JSON"
            value={assignment?.path || undefined}
            onChange={(value) => handleManualNerAssignment(fieldKey, value)}
            options={jsonFieldSelectOptions}
            optionFilterProp="label"
            style={{ width: '100%' }}
            disabled={readOnly}
        />
    );

    const renderNerSummarySection = (title, fields) => {
        if (!fields.length) {
            return null;
        }
        return (
            <div style={{ marginBottom: 16 }}>
                <Text strong style={{ display: 'block', marginBottom: 12 }}>{title}</Text>
                {fields.map((field, index) => {
                    const assignment = nerFieldAssignments[field.key];
                    return (
                        <div
                            key={field.key}
                            style={{
                                display: 'flex',
                                gap: 24,
                                flexWrap: 'wrap',
                                marginBottom: index !== fields.length - 1 ? 16 : 0,
                            }}
                        >
                            <div style={{ flex: '1 1 220px', display: 'flex', flexDirection: 'column' }}>
                                <Text type="secondary">{field.label}:</Text>
                                <div style={{ marginTop: 8 }}>
                                    {renderNerFieldSelector(assignment, field.key)}
                                </div>
                            </div>
                            <div style={{ flex: '2 1 260px', display: 'flex', flexDirection: 'column' }}>
                                <Text type="secondary">Value:</Text>
                                <div
                                    style={{
                                        marginTop: 8,
                                        height: 32,
                                        boxSizing: 'border-box',
                                        border: '1px solid #f0f0f0',
                                        borderRadius: 10,
                                        padding: '4px 11px',
                                        background: '#fafafa',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    {(assignment && assignment.value) ? assignment.value : '-'}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div
            className="response-step-card__ner-summary"
            style={{
                marginTop: 16,
                border: '1px solid #e5e5e5',
                borderRadius: 12,
                padding: 16,
                background: '#fff',
            }}
        >
            {renderNerSummarySection('Entities', entityFieldConfig)}
            {supportsRelationFields && renderNerSummarySection('Relations', relationFieldConfig)}
        </div>
    );
};

export default NerSummary;

